/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

function initTeamSearch () {
  $('.team-members .doc-search-input input').keyup(function () {
    const curTeamSearch = $(this).val().replace(/(^\s+|\s+$)/g, '').toLowerCase()
    $('.team-members .person').each(function () {
      const $tile = $(this)
      const vis = !curTeamSearch.length || $tile.text().toLowerCase().indexOf(curTeamSearch) >= 0

      if (vis) {
        $tile.stop().fadeIn('fast')
      } else {
        $tile.stop().fadeOut('fast')
      }
    })
  })
}

$(document).on('pjax:end', initTeamSearch)
initTeamSearch()
